// extracted by mini-css-extract-plugin
export default {"addTFormHeader__returnPage":"AddTFormHeader_addTFormHeader__returnPage__MrT78"};